import type { ComponentDefinition } from "../types";

export const SOURCE: ComponentDefinition[] = [
  {
    id: "src-alternator",
    name: "Engine Alternator",
    shortName: "Alternator",
    subtitle: "Separate alt output 100A",
    category: "source",
    ampOutput: 100,
    chargeAmpsTypical: 60,
    width: 200,
    height: 110,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 150,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 150,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-alternator-balmar-6series",
    name: "Balmar 6-Series 150A",
    shortName: "6-Series 150A",
    subtitle: "Separate alt output 150A",
    category: "source",
    manufacturer: "Balmar",
    model: "6-Series 150A",
    // Ratings per the balmar.net 6-Series page.
    ampOutput: 150,
    chargeAmpsTypical: 90,
    width: 210,
    height: 115,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 200,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 200,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
    image: "src-alternator-balmar-6series.webp",
  },
  {
    id: "src-alternator-small-frame",
    name: "Small-frame Alternator 70A",
    shortName: "Alt 70A",
    subtitle: "OEM small-frame 70A",
    category: "source",
    ampOutput: 70,
    chargeAmpsTypical: 40,
    width: 200,
    height: 110,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 100,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 100,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-alternator-80",
    name: "Alternator 80A",
    shortName: "Alt 80A",
    subtitle: "Marine alternator 80A",
    category: "source",
    ampOutput: 80,
    chargeAmpsTypical: 45,
    width: 200,
    height: 110,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 100,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 100,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-alternator-automotive-140",
    name: "Automotive Alternator 140A",
    shortName: "Auto Alt 140A",
    subtitle: "Vehicle alternator 140A",
    category: "source",
    ampOutput: 140,
    chargeAmpsTypical: 80,
    width: 200,
    height: 110,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 200,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 200,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-alternator-balmar-xt250",
    name: "Balmar XT-250 (Lithium)",
    shortName: "XT-250 250A",
    subtitle: "Lithium-capable 250A",
    category: "source",
    manufacturer: "Balmar",
    model: "XT-250",
    // balmar.net XT-Series: MC-614 is the 12 V regulator.
    ampOutput: 250,
    chargeAmpsTypical: 180,
    width: 210,
    height: 115,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 300,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 300,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
    image: "src-alternator-balmar-xt250.webp",
  },
  {
    id: "src-alternator-nations-280xp",
    name: "Nations 280XP",
    shortName: "280XP 280A",
    subtitle: "High-output alternator 280A",
    category: "source",
    manufacturer: "Nations",
    model: "280XP",
    ampOutput: 280,
    chargeAmpsTypical: 200,
    width: 210,
    height: 115,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 350,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 350,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
    image: "src-alternator-nations-280xp.webp",
  },
  {
    id: "src-generator",
    name: "Honda EU2200i Generator",
    shortName: "EU2200i",
    subtitle: "Inverter generator 1800W",
    category: "source",
    manufacturer: "Honda",
    model: "EU2200i",
    watts: 1800,
    width: 220,
    height: 120,
    terminals: [
      {
        id: "ac-l",
        label: "AC L",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.3,
        maxAmp: 15,
      },
      {
        id: "ac-n",
        label: "AC N",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.5,
        maxAmp: 15,
      },
      {
        id: "ac-pe",
        label: "AC ⏚",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 16,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
    image: "src-generator.webp",
  },
  {
    id: "src-yamaha-ef2200",
    name: "Yamaha EF2200iS",
    shortName: "EF2200iS",
    subtitle: "Inverter generator 1800W",
    category: "source",
    manufacturer: "Yamaha",
    model: "EF2200iS",
    watts: 1800,
    width: 220,
    height: 120,
    terminals: [
      {
        id: "ac-l",
        label: "AC L",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.3,
        maxAmp: 15,
      },
      {
        id: "ac-n",
        label: "AC N",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.5,
        maxAmp: 15,
      },
      {
        id: "ac-pe",
        label: "AC ⏚",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 15,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
    image: "src-yamaha-ef2200.webp",
  },
  {
    id: "src-shore-16a",
    acVoltage: 230,
    name: "Shore Power 230V/16A",
    shortName: "Shore 16A",
    subtitle: "Power inlet 230V/16A",
    category: "source",
    width: 200,
    height: 110,
    terminals: [
      {
        id: "ac-l",
        label: "AC L",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.3,
        maxAmp: 16,
      },
      {
        id: "ac-n",
        label: "AC N",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.5,
        maxAmp: 16,
      },
      {
        id: "ac-pe",
        label: "AC ⏚",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 16,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "connected",
          label: "Connected",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-shore-30a-us",
    acVoltage: 120,
    name: "Shore Power 120V/30A",
    shortName: "Shore 30A",
    subtitle: "Power inlet 120V/30A",
    category: "source",
    width: 200,
    height: 110,
    terminals: [
      {
        id: "ac-l",
        label: "AC L",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.3,
        maxAmp: 30,
      },
      {
        id: "ac-n",
        label: "AC N",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.5,
        maxAmp: 30,
      },
      {
        id: "ac-pe",
        label: "AC ⏚",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.7,
        maxAmp: 30,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "connected",
          label: "Connected",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-shore-50a-us",
    acVoltage: 120,
    name: "Shore Power 120/240V 50A",
    shortName: "Shore 50A",
    subtitle: "Power inlet 120/240V/50A",
    category: "source",
    width: 200,
    height: 110,
    terminals: [
      {
        id: "ac-l1",
        label: "L1",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.25,
        maxAmp: 50,
      },
      {
        id: "ac-l2",
        label: "L2",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.45,
        maxAmp: 50,
      },
      {
        id: "ac-n",
        label: "N",
        polarity: "neutral",
        direction: "output",
        side: "right",
        offset: 0.65,
        maxAmp: 50,
      },
      {
        id: "ac-pe",
        label: "⏚",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.85,
        maxAmp: 50,
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "connected",
          label: "Connected",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-bluetti-ac180",
    name: "Bluetti AC180 Power Station",
    shortName: "Bluetti AC180",
    subtitle: "Portable power station, 12V/10A DC",
    category: "source",
    manufacturer: "Bluetti",
    model: "AC180",
    capacityAh: 90,
    voltage: 12,
    ampOutput: 10,
    width: 200,
    height: 110,
    terminals: [
      {
        id: "out-pos",
        label: "12V +",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.35,
        maxAmp: 10,
      },
      {
        id: "out-neg",
        label: "12V −",
        polarity: "negative",
        direction: "output",
        side: "right",
        offset: 0.65,
        maxAmp: 10,
      },
    ],
  },
  {
    id: "src-alternator-hpi-185-24",
    name: "High-Output Alternator 24V 185A",
    shortName: "HPI 185A 24V",
    subtitle: "External-reg alternator 185A",
    category: "source",
    manufacturer: "APS",
    model: "185 HPI",
    ampOutput: 185,
    chargeAmpsTypical: 150,
    voltage: 24,
    width: 210,
    height: 120,
    terminals: [
      {
        id: "pos",
        label: "B+",
        polarity: "positive",
        direction: "output",
        side: "right",
        offset: 0.3,
        maxAmp: 250,
      },
      {
        id: "neg",
        label: "GND",
        polarity: "ground",
        direction: "bidi",
        side: "right",
        offset: 0.6,
        maxAmp: 250,
      },
      {
        id: "field",
        label: "Field",
        polarity: "signal",
        direction: "input",
        side: "right",
        offset: 0.85,
        maxAmp: 1,
        color: "#f59e0b",
      },
    ],
    simulateStates: {
      default: "off",
      options: [
        {
          id: "running",
          label: "Running",
        },
        {
          id: "off",
          label: "Off",
          ampOverride: 0,
        },
      ],
    },
  },
  {
    id: "src-zeus-regulator",
    name: "Arco Zeus Alternator Regulator",
    shortName: "Zeus Regulator",
    subtitle: "External alternator regulator",
    category: "source",
    manufacturer: "Arco Marine",
    model: "Zeus",
    ampDraw: 0.5,
    // Zeus installation guide, printed p19: BAT V+ is 12 V only.
    voltage: 12,
    // Supply compatibility; the separately sensed/regulated bank may be 12–48 V.
    compatibleVoltages: [12],
    width: 190,
    height: 110,
    terminals: [
      {
        id: "bat-pos",
        label: "BAT V+",
        polarity: "positive",
        direction: "input",
        side: "left",
        offset: 0.35,
        maxAmp: 10,
      },
      {
        id: "bat-neg",
        label: "BAT GND",
        polarity: "ground",
        direction: "input",
        side: "left",
        offset: 0.7,
        maxAmp: 10,
      },
      {
        id: "field",
        label: "Field",
        polarity: "signal",
        direction: "output",
        side: "right",
        offset: 0.5,
        maxAmp: 1,
        color: "#f59e0b",
      },
    ],
    image: "src-zeus-regulator.webp",
  },
  {
    id: "src-wakespeed-ws500",
    name: "Wakespeed WS500 Alternator Regulator",
    shortName: "WS500 Regulator",
    subtitle: "External alternator regulator",
    category: "source",
    manufacturer: "Wakespeed",
    model: "WS500",
    ampDraw: 0.5,
    voltage: 12,
    compatibleVoltages: [12, 24, 48],
    width: 190,
    height: 110,
    terminals: [
      {
        id: "bat-pos",
        label: "BAT V+",
        polarity: "positive",
        direction: "input",
        side: "left",
        offset: 0.35,
        maxAmp: 10,
      },
      {
        id: "bat-neg",
        label: "BAT GND",
        polarity: "ground",
        direction: "input",
        side: "left",
        offset: 0.7,
        maxAmp: 10,
      },
      {
        id: "field",
        label: "Field",
        polarity: "signal",
        direction: "output",
        side: "right",
        offset: 0.5,
        maxAmp: 15,
        color: "#f59e0b",
      },
    ],
    image: "src-wakespeed-ws500.webp",
  },
  // Manufacturer evidence and model boundaries: docs/research/component-manuals-common-50-2026-10-01.md.
  {
    "id": "alt-reg-balmar-mc-618",
    "image": "alt-reg-balmar-mc-618.webp",
    "name": "Balmar MC-618 Alternator Regulator",
    "shortName": "MC-618",
    "subtitle": "External alternator regulator",
    "category": "source",
    "manufacturer": "Balmar",
    "model": "MC-618",
    "voltage": 12,
    "compatibleVoltages": [
      12
    ],
    "width": 225,
    "height": 145,
    "terminals": [
      {
        "id": "power",
        "label": "POWER RED",
        "polarity": "positive",
        "direction": "input",
        "maxAmp": 15,
        "side": "left",
        "offset": 0.2
      },
      {
        "id": "neg",
        "label": "GROUND BLACK",
        "polarity": "negative",
        "direction": "input",
        "maxAmp": 15,
        "side": "left",
        "offset": 0.5
      },
      {
        "id": "ignition",
        "label": "IGN BROWN",
        "polarity": "signal",
        "direction": "input",
        "maxAmp": 0,
        "side": "left",
        "offset": 0.8
      },
      {
        "id": "field",
        "label": "FIELD BLUE",
        "polarity": "signal",
        "direction": "output",
        "maxAmp": 15,
        "side": "right",
        "offset": 0.3
      },
      {
        "id": "v-sense",
        "label": "B+ SENSE",
        "polarity": "signal",
        "direction": "input",
        "maxAmp": 0,
        "side": "right",
        "offset": 0.7
      }
    ]
  },
  {
    "id": "src-smartplug-bm30nt",
    "name": "SmartPlug BM30NT 30A 125V Inlet",
    "shortName": "BM30NT 30A",
    "subtitle": "125V AC shore inlet",
    "category": "source",
    "manufacturer": "SmartPlug",
    "model": "BM30NT",
    "voltage": 120,
    "ampOutput": 30,
    "width": 230,
    "height": 140,
    "terminals": [
      {
        "id": "ac-l",
        "label": "AC L",
        "polarity": "neutral",
        "direction": "output",
        "side": "right",
        "offset": 0.3,
        "maxAmp": 30
      },
      {
        "id": "ac-n",
        "label": "AC N",
        "polarity": "neutral",
        "direction": "output",
        "side": "right",
        "offset": 0.5,
        "maxAmp": 30
      },
      {
        "id": "ac-pe",
        "label": "AC PE",
        "polarity": "ground",
        "direction": "bidi",
        "side": "right",
        "offset": 0.7,
        "maxAmp": 30
      }
    ]
  },
  // Additional manufacturer-reviewed models; evidence: docs/research/component-manuals-additional-50-2026-10-01.md
  {
    "id": "src-efoy-80",
    "image": "src-efoy-80.webp",
    "name": "EFOY 80 Fuel Cell (12 V configuration)",
    "shortName": "EFOY 80",
    "subtitle": "Methanol fuel-cell battery charger, 40 W rated maximum and 3.8 A peak at 10.5 V",
    "category": "source",
    "manufacturer": "EFOY",
    "model": "EFOY 80",
    "terminals": [
      {
        "id": "out-pos",
        "label": "POWER +",
        "polarity": "positive",
        "direction": "output",
        "maxAmp": 0,
        "side": "left",
        "offset": 0.25
      },
      {
        "id": "out-neg",
        "label": "POWER −",
        "polarity": "negative",
        "direction": "output",
        "maxAmp": 0,
        "side": "left",
        "offset": 0.65
      },
      {
        "id": "sense-pos",
        "label": "SENSE +",
        "polarity": "signal",
        "direction": "bidi",
        "maxAmp": 0,
        "side": "bottom",
        "offset": 0.3
      },
      {
        "id": "sense-neg",
        "label": "SENSE −",
        "polarity": "signal",
        "direction": "bidi",
        "maxAmp": 0,
        "side": "bottom",
        "offset": 0.7
      }
    ],
    "width": 180,
    "height": 130,
    "watts": 40,
    "ampOutput": 3.8,
    "voltage": 12,
    "compatibleVoltages": [
      12
    ],
    "simulateStates": {
      "default": "off",
      "options": [
        {
          "id": "rated",
          "label": "Rated output (temperature / age / control dependent)",
          "ampMultiplier": 1,
          "role": "output"
        },
        {
          "id": "off",
          "label": "Sleep / standby (antifreeze not predicted)",
          "ampOverride": 0
        }
      ]
    }
  },
  {
    "id": "src-marlec-rutland-1200-12v",
    "image": "src-marlec-rutland-1200-12v.webp",
    "name": "Marlec Rutland 1200 + Hybrid MPPT Controller 12 V",
    "shortName": "Rutland 1200 + 12 V Hybrid MPPT",
    "subtitle": "Wind turbine and required controller bundle",
    "category": "source",
    "manufacturer": "Marlec",
    "model": "Rutland 1200 + 12 V Hybrid MPPT",
    "terminals": [
      {
        "id": "out-pos",
        "label": "BATTERY 1 +",
        "polarity": "positive",
        "direction": "output",
        "maxAmp": 0,
        "side": "right",
        "offset": 0.1
      },
      {
        "id": "out-neg",
        "label": "BATTERY 1 −",
        "polarity": "negative",
        "direction": "output",
        "maxAmp": 0,
        "side": "right",
        "offset": 0.5
      },
      {
        "id": "bank2-pos",
        "label": "BATTERY 2 +",
        "polarity": "positive",
        "direction": "output",
        "maxAmp": 0,
        "side": "right",
        "offset": 0.55
      },
      {
        "id": "bank2-neg",
        "label": "BATTERY 2 −",
        "polarity": "negative",
        "direction": "output",
        "maxAmp": 0,
        "side": "right",
        "offset": 0.9500000000000001
      },
      {
        "id": "pv-pos",
        "label": "OPTIONAL PV +",
        "polarity": "positive",
        "direction": "input",
        "maxAmp": 20,
        "side": "left",
        "offset": 0.25
      },
      {
        "id": "pv-neg",
        "label": "OPTIONAL PV −",
        "polarity": "negative",
        "direction": "input",
        "maxAmp": 20,
        "side": "left",
        "offset": 0.65
      },
      {
        "id": "sense1",
        "label": "REMOTE BAT 1 +",
        "polarity": "signal",
        "direction": "bidi",
        "maxAmp": 0,
        "side": "bottom",
        "offset": 0.2
      },
      {
        "id": "sense2",
        "label": "REMOTE BAT 2 +",
        "polarity": "signal",
        "direction": "bidi",
        "maxAmp": 0,
        "side": "bottom",
        "offset": 0.5
      },
      {
        "id": "temp",
        "label": "REMOTE TEMPERATURE",
        "polarity": "signal",
        "direction": "bidi",
        "maxAmp": 0,
        "side": "bottom",
        "offset": 0.8
      }
    ],
    "width": 180,
    "height": 130,
    "voltage": 12,
    "pvMaxVoc": 50,
    "compatibleVoltages": [
      12
    ],
    "simulateStates": {
      "default": "stopped",
      "options": [
        {
          "id": "running",
          "label": "Running; wind output unpredicted",
          "intraLinks": []
        },
        {
          "id": "stopped",
          "label": "WG / PV stopped",
          "ampOverride": 0,
          "intraLinks": []
        }
      ]
    }
  },
  {
    "id": "src-wattandsea-cruising-300-12v",
    "image": "src-wattandsea-cruising-300-12v.webp",
    // Cruising V5 PDF p. 15: solar negative is common with the battery negative.
    internalDcConnections: [["pv-neg", "out-neg"]],
    "name": "Watt&Sea Cruising 300 + CV-03 Converter (12 V)",
    "shortName": "Cruising 300 H-300-03 + CV-03",
    "subtitle": "300 W hydrogenerator with mandatory CV-03 converter",
    "category": "source",
    "manufacturer": "Watt&Sea",
    "model": "Cruising 300 H-300-03 + CV-03",
    "terminals": [
      {
        "id": "out-pos",
        "label": "BATTERY 1 +",
        "polarity": "positive",
        "direction": "output",
        "maxAmp": 44,
        "side": "right",
        "offset": 0.1
      },
      {
        "id": "out-neg",
        "label": "COMMON BATTERY −",
        "polarity": "negative",
        "direction": "output",
        "maxAmp": 44,
        "side": "right",
        "offset": 0.8
      },
      {
        "id": "bank2-pos",
        "label": "BATTERY 2 +",
        "polarity": "positive",
        "direction": "output",
        "maxAmp": 44,
        "side": "right",
        "offset": 0.55
      },
      {
        "id": "pv-pos",
        "label": "OPTIONAL PV +",
        "polarity": "positive",
        "direction": "input",
        "maxAmp": 14,
        "side": "left",
        "offset": 0.25
      },
      {
        "id": "pv-neg",
        "label": "OPTIONAL PV −",
        "polarity": "negative",
        "direction": "input",
        "maxAmp": 14,
        "side": "left",
        "offset": 0.65
      }
    ],
    "width": 180,
    "height": 130,
    "watts": 300,
    "voltage": 12,
    "pvMaxVoc": 50,
    "compatibleVoltages": [
      12
    ],
    "simulateStates": {
      "default": "raised",
      "options": [
        {
          "id": "deployed",
          "label": "Deployed; water-speed output unpredicted",
          "intraLinks": []
        },
        {
          "id": "raised",
          "label": "Raised / stopped",
          "ampOverride": 0,
          "intraLinks": []
        }
      ]
    }
  },
];
